import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Lenspire_Icon_ZoomIn",
  "use": "Lenspire_Icon_ZoomIn-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"Lenspire_Icon_ZoomIn\">\n<g>\n\t<path d=\"M7,24H0v-7c0-0.553,0.448-1,1-1s1,0.447,1,1v5h5c0.552,0,1,0.447,1,1S7.552,24,7,24z\" />\n</g>\n<g>\n\t<path d=\"M24,24h-7c-0.553,0-1-0.447-1-1s0.447-1,1-1h5v-5c0-0.553,0.447-1,1-1s1,0.447,1,1V24z\" />\n</g>\n<g>\n\t<path d=\"M23,8c-0.553,0-1-0.447-1-1V2h-5c-0.553,0-1-0.447-1-1s0.447-1,1-1h7v7C24,7.553,23.553,8,23,8z\" />\n</g>\n<g>\n\t<path d=\"M1,8C0.448,8,0,7.553,0,7V0h7c0.552,0,1,0.447,1,1S7.552,2,7,2H2v5C2,7.553,1.552,8,1,8z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./frontend/assets/icons/Lenspire_Icon_ZoomIn.svg
// module id = 542
// module chunks = 0